import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import { math } from "../../../utils";

gsap.registerPlugin(ScrollTrigger);

class BioFutureTimeline {
    constructor(el) {
        this.el = el;
        this.navItems = [...document.querySelectorAll(".bh-timeline-nav-item")];
        this.progressDot = document.getElementById('bh-timeline-nav--active')
        this.items = document.querySelectorAll('.bh-timeline-item');
        this.pinArrow = document.getElementById('pin-arrow');
        this.previousStateIsMobile = this.isMobileView();
        this.bind();
        this.init();
    }

    bind() {
        this.handleSlides = this.handleSlides.bind(this);
    }

    isMobileView() {
        return window.innerWidth < 768;
    }

    init() {
        this.currentTransitionSpeed = 0;
        // this.initScrollTrigger();
        this.initSlider();
        this.setupBreakpointListener();
        this.initPinEvents();
    }

    setupBreakpointListener() {
        // window.addEventListener('resize', this.handleBreakpointChange.bind(this));
    }

    handleBreakpointChange() {
        const currentStateIsMobile = this.isMobileView();

        if (currentStateIsMobile !== this.previousStateIsMobile) {
            this.initSlider();
            this.previousStateIsMobile = currentStateIsMobile;
        }
    }

    initPinEvents () {
        const that = this;
        this.navItems.forEach((item, index) => {
            item.addEventListener('click', (event) => {
                that.handleSlides(index);
            });
        });
    }

    initSlider() {
        const that = this;
        const isMobile = this.isMobileView();

        this.timelineSlider = new Swiper('.bh-timeline-slider', {
            slidesPerView: 1,
            autoHeight: false,
            watchSlidesProgress: true,
            allowTouchMove: true,
            speed: 800,

            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },

            on: {
                progress(e) {
                    for (let r = 0; r < e.slides.length; r += 1) {
                        const slide = e.slides[r].firstElementChild;
                        let opacity = 1;
                        let scale = 1;

                        if(!isMobile) {
                            const progress = e.slides[r].progress;
                            const absProgress = Math.abs(progress);

                            opacity = 1 - absProgress;
                            opacity = opacity < 0 ? 0 : opacity;

                            scale = 1.05 - .2 * absProgress;
                            scale = scale > 0.85 ? scale : 0.85;

                            let delta = math.lerp(0, -45, absProgress);
                            delta = delta > -45 ? delta : -45;
                        }
                        slide.style.opacity = opacity;
                        slide.style.transform = `scale(${scale})`;
                    }
                },
                setTransition(e, t) {
                    for (let r = 0; r < e.slides.length; r += 1) {
                        const o = e.slides[r].firstElementChild;
                        o.style.transitionDuration = `${t}ms`;
                    }
                },
                slideChangeTransitionStart(e, t) {
                    const activeSlideIndex = e.activeIndex;
                    const activeSlide = e.slides[activeSlideIndex];
                    const position = activeSlide.firstElementChild.dataset.begin;
                    that.moveProgressDot(position)
                    that.handleLastSlide(activeSlideIndex);
                }
            }
        });
    }

    moveProgressDot(position) {
        gsap.to(this.progressDot, {
            left: `${ position }%`,
            duration: 0.8
        })
    }

    handleLastSlide(index) {
        if(index === this.items.length - 1) {
            gsap.timeline()
                .to(this.pinArrow, {
                    y: 5,
                    duration: 0.25,
                    ease: "none"
                })
                .to(this.pinArrow, {
                    y: -5,
                    duration: 0.5,
                    ease: "none"
                })
                .to(this.pinArrow, {
                    y: 5,
                    duration: 0.5,
                    ease: "none"
                })
                .to(this.pinArrow, {
                    y: -5,
                    duration: 0.5,
                    ease: "none"
                })
                .to(this.pinArrow, {
                    y: 5,
                    duration: 0.5,
                    ease: "none"
                })
                .to(this.pinArrow, {
                    y: -5,
                    duration: 0.5,
                    ease: "none"
                })
                .to(this.pinArrow, {
                    y: 0,
                    duration: 0.25,
                    ease: "none"
                })
        }
    }

    handleSlides(currentIndex) {
        this.timelineSlider.slideTo(currentIndex);
    }
}

export default BioFutureTimeline
